var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0c-8.812 0-16 7.188-16 16s7.188 16 16 16c0.148 0 0.246 0 0.394 0v-11.52h-4.825v-4.825h4.825v-2.855c0-3.988 2.511-6.105 6.006-6.105 1.723 0 2.708-0.098 3.643 0v4.086h-3.2c-1.822 0-2.609 1.083-2.609 2.412v2.412h4.923l-0.541 4.874h-4.332v10.979c6.745-1.92 11.717-8.123 11.717-15.459 0-8.812-7.188-16-16-16z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/icon-facebook.f9521807a21ccbeb548b83ec037b451d.svg";
export { ForwardRef as ReactComponent };